module.exports = __webpack_public_path__ + "img/48.a1f6b7e2.png";